<template>
    <mdc-dialog class="appeals-modal"
                v-model="isOpen"
                :title="'appeals.write_client_appeal' | trans"
                :accept="'appeals.buttons.createAppeal' | trans"
                @cancel="cancel"
                @close="close"
                :accept-disabled="disabled || (isPreviousDateSession && !currentDate())"
                @validate="validate"
                :class="{'fullscreen-dialog' : isMobile}">

        <div v-if="!isMobile" class="close-cross" @click="cancel()">
            <mdc-icon icon="close"></mdc-icon>
        </div>

        <div v-else>
            <mdc-toolbar slot="toolbar"
                         class="navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-4 mb-md-4">
                <div class="container">
                    <!--  toolbar markup here -->
                    <mdc-toolbar-row>
                        <mdc-toolbar-section shrink-to-fit>
                            <span @click="cancel()">
                                <mdc-icon icon="close"></mdc-icon>
                            </span>
                            <h3 class="title">{{'appeals.write_appeal' | trans}}</h3>
                        </mdc-toolbar-section>
                        <mdc-toolbar-section align-end>
                            <span @click.prevent="validate()">
                                <mdc-icon class="done" icon="done"></mdc-icon>
                            </span>
                        </mdc-toolbar-section>
                    </mdc-toolbar-row>
                </div>
            </mdc-toolbar>
        </div>

        <div class="form-group row">
            <div class="col-md-12">
                <div v-for="(appeal, index) in typicalAppealsTemp" :key="index"
                     class="radio-btn selectable"
                     :class="{'active' : appeal.selected}"
                     @click="setActiveAppeal(appeal)">
                    {{appeal.text}}
                </div>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <div class="col-8 col-md-9">
                <mdc-textfield v-model="newAppeal.text"
                               name="newAppeal"
                               :class="{'is-invalid': errors.has('newAppeal || isEmptyError || isMaxLengthAppeals')}"
                               type="text"
                               v-validate="'min:1|max:100'"
                               data-vv-validate-on="none"
                               :data-vv-as="'appeals.appeals' | trans"
                               :label="'appeals.type_new_appeal' | trans"
                               v-on:keyup.enter="addAppeal"/>
            </div>

            <div class="col-4 col-md-3">
                <button type="button" class="col-12 mdc-button mdc-button--raised button-primary" @click="addAppeal()">
                    <span>{{'appeals.buttons.addAppeal' | trans}}</span>
                </button>
            </div>

            <div class="col-md-12">
                <span class="invalid-feedback-label" v-if="errors.has('newAppeal') || errors.has('isEmptyError') || errors.has('isMaxLengthAppeals')">
                  <strong>{{ errors.first('newAppeal') || errors.first('isEmptyError') || errors.first('isMaxLengthAppeals') }}</strong>
                </span>
            </div>
        </div>

        <footer class="col-12 px-0 mdc-dialog__footer mdc-dialog__footer--visible" v-if="isMobile">
            <button type="button" :disabled="disabled || (isPreviousDateSession && !currentDate())" class="col-12 mdc-button mdc-button--raised button-primary" @click="validate()">
                <span>{{'appeals.buttons.createAppeal' | trans}}</span>
            </button>
        </footer>
    </mdc-dialog>
</template>

<script>
  import $ from 'jquery';
  import apiAppeals from '../api/appeals'
  import cloneDeep from 'lodash/cloneDeep';
  import {mapGetters, mapActions, mapState} from 'vuex';
  import lang from '../../../lang/translator';
  import trim from 'lodash/trim';
  import Constants from '../Constants';
  import forEach from 'lodash/forEach';
  import findIndex from 'lodash/findIndex';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import moment from 'moment';

  export default {
    name: 'appealsAddModal',
    props: {
      'clientData': {
        type: [Array, Object],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        typicalAppealsTemp: [],
        newAppeal: {
          text: '',
          id: null
        },
        disabled: false
      };
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        }
      },
      ...mapGetters('mobile', [
        'isMobile',
      ]),

      ...mapState('appeals', [
        'typicalAppeals',
        'entity',
      ]),
      ...mapGetters('auth', [
        'isPreviousDateSession',
        'previousDate',
        'previousTime',
        'previousDuration'
      ]),
      
    },
    created () {
      if (this.clientId) {
        this.setTypesAppeals(this.clientId);
      }
    },
    mounted (){
      /*if (!this.uiid){
        this.uiid = UuidGenerator.v4()
        let entity = {
          id: this.uiid,
          type: 'assigned-session',
        };

        this.setEntity(entity);
      }*/

      if(!(this.$route.name === 'current-stage' ||
              this.$route.name === 'mand-stage-current' ||
              this.$route.name === 'chain-stage-current' ||
              this.$route.name === 'shaping-stage-current' ||
              this.$route.name === 'mastering-stage' ||
              this.$route.name === 'rotation-stage' ||
              this.$route.name === 'fluency-stage' ||
              this.$route.name === 'maintain-stage' ||
              this.$route.name === 'mastering-stage-usd' ||
              this.$route.name === 'pecs-stage' ||
              this.$route.name === 'pecs-stage-without-discrimination' ||
              this.$route.name === 'pecs-with-discrimination-stage' ||
              this.$route.name === 'pecs-with-items-stage' ||
              this.$route.name === 'maintain-stage-usd')){

        this.setEntity({});

      }
    },
    beforeDestroy() {

    },

    methods: {
      ...mapActions('appeals', [
        'setIsAdded',
        'setTypesAppeals',
        'setEntity'
      ]),

      currentDate() {
        let clientTimeZoneOffset = this.clientData ? moment().tz(this.clientData.timezone)._offset : 0;
        let createdAt = Math.round((new Date()).getTime() / 1000);
        if (this.previousDate && this.previousTime && this.previousTime.HH && this.previousTime.mm) {
          createdAt = this.isPreviousDateSession ?
            moment(new Date(Date.UTC(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm))).unix() -
            (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE) :
            Math.round((new Date()).getTime() / 1000);
        }
        return createdAt;
      },

      async validate() {
        this.errors.clear();

        let result = await this.$validator.validateAll();

        if (result && (findIndex(this.typicalAppealsTemp, ['selected', true]) >= 0)) {
          let tempTypicalAppeals = cloneDeep(this.typicalAppealsTemp);

          try {
            this.disabled = true;

            let createdAt = this.currentDate();

            let response = await apiAppeals.create(this.clientId, tempTypicalAppeals, this.entity, createdAt);
            this.setIsAdded(true);
            this.setTypesAppeals(this.clientId);
            this.close();
          } catch (error) {
            console.dir(error)
          } finally{
            this.disabled = false;
          }

        }
        else if (findIndex(this.typicalAppealsTemp, ['selected', true]) < 0) {
          this.errors.add({
            field: 'isEmptyError',
            msg: lang.get('appeals.need_choice_appeal')
          });
        }
      },

      async addAppeal() {
        let createdAt = this.currentDate();

        if (this.typicalAppealsTemp.length < Constants.MAX_LENGTH) {

          let result = await this.$validator.validateAll();

          if (result  && this.newAppeal.text !== '') {
            this.disabled = true;
            let uniqueCounter = 0;

            for (let typicalTypicalAppeal of this.typicalAppealsTemp) {
              if (trim(typicalTypicalAppeal.text.toLowerCase()) === trim(this.newAppeal.text.toLowerCase())) {
                uniqueCounter++;
                this.newAppeal.text = '';

                this.$nextTick(() => {
                  if (this.isMobile) {
                    $('.mdc-dialog').animate({scrollTop: $(".radio-btn.active").offset().top - 10}, 500);
                  }
                });
              }
            }

            if (uniqueCounter === 0) {
              let newAppeal = {
                id: null,
                index: Math.random(),
                text: this.newAppeal.text,
                selected: true,
                createdAt: createdAt
              }
              this.typicalAppealsTemp.push(newAppeal);
              this.newAppeal.text = '';
            }
            this.disabled = false;
          }
          else if (this.newAppeal.text == '') {
            this.errors.add({
              field: 'isEmptyError',
              msg: lang.get('appeals.type_new_appeal')
            });
          }
        }
        else {
          this.errors.add({
            field: 'isMaxLengthAppeals',
            msg: lang.get('appeals.maxlength_appeals')
          });
        }

      },

      setActiveAppeal(appeal) {
        let attempts = cloneDeep(this.typicalAppealsTemp);

        forEach(attempts, (item) => {
          if(item.index == appeal.index){
            item.selected = !item.selected
          }
        });

        this.typicalAppealsTemp = attempts;
      },

      reset() {
        this.typicalAppealsTemp = cloneDeep(this.typicalAppeals);
        forEach(this.typicalAppealsTemp, (item) => {
          item.index = item.id;
          item.selected = false;
          let convertDate = this.currentDate();
          item.createdAt = convertDate;
        });
        this.errors.clear();
      },

      close() {
        this.reset();
        this.$emit('close');
      },

      cancel() {
        this.reset();
        this.$emit('cancel');
      },
    },
    watch: {
      typicalAppeals() {
        this.typicalAppealsTemp = cloneDeep(this.typicalAppeals)

        forEach(this.typicalAppealsTemp, (item, index) => {
          item.selected = false
          item.index = item.id;
          let convertDate = this.currentDate();
          item.createdAt = convertDate;
        });
        
      },
      clientId() {
        this.setTypesAppeals(this.clientId);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/modules/appeals/components/AddModal.vue